<template>
	
  <div class="certifikat ovoj" id="html">
	<kbutton class="gumbtiskaj" :theme-color="'primary'" :rounded="'full'" id="tiskaj">
			<font-awesome-icon icon="print"  size="6x"/>
	</kbutton>
    <div class="levi-stolpec">
     <div class="levi-logo"></div> 
     <div class="levi-stolpec-napis">
      <div class="eko-napis">{{__("Integrirana pridelava")}}</div>
     </div>
   </div>

     <div id="prvi-del">
       <!-- <div class="levi-logo">
          <img src='~@/assets/ikc.png'/>
        </div>-->
        
        <div class="glava mali-ovoj">
            
            <div class="glava certifikat">
                <h1 class=" accent">{{__("CERTIFIKAT")}}</h1>
				<h2 class=" accent">{{__("CERTIFICATE")}}</h2>
                
            </div>
            
        </div>
         
     <!--<div class="levi-stolpec">
      <div class="eko-napis">Ekološko kmetijstvo</div>
     </div>
   -->
     
      <!-- 1-4 -->
      <div class="celotna-sekcija">
      
	
			<div class="vrstica">
				<div class="imetnik">{{__("Imetnik / Operator")}}</div>
				<div class="imetnik accent">{{certifikat.imetnik}}</div>
			</div>
			<div class="vrstica">
				<div class="naslov">{{__("Naslov / Address")}}</div>
				<div class="naslov accent">{{certifikat.naslov}}</div>
			</div>

			<div class="vrste">
				<div class="vrsta">{{__("Vrste certificiranih kmetijskih rastlin / Types of certified agricultural plants")}}</div>
				<div class="vrsta accent" v-for="vrsta in certifikat.vrsterastlin" :key="vrsta.šifra">
				{{vrsta.naziv}}
				</div>
			</div>

			<div class="podatki">
				<div class="podatek">
					<div class="kntstevilka">{{__("Kontrolna številka")}}</div>
					<div class="kntstevilka accent">{{certifikat.kontrolnastevilka}}</div>
				</div>
				<div class="podatek">
					<div class="stcert">{{__("Številka certifikata")}}</div>
					<div class="stcert accent">{{certifikat.stcertifikata}}</div>
				</div>
				<div class="podatek">
					<div class="veljavnost">{{__("Certifikat je veljaven od")}}:</div>
					<div class="veljavnost accent">{{certifikat.datumizdaje}}</div>
					<div class="veljavnost">{{__("do")}}</div>
					<div class="veljavnost accent">{{certifikat.datumveljavnosti}}</div>

				</div>
				<div v-if="certifikat.stariCertifikat" class="podatek">
					<div>{{__("Ta certifikat zamenjuje predhodni certifikat št.:")}}</div>
        			<div>{{certifikat.stariCertifikat}}</div>
      			</div>
				

				  <div class="podatek mt-1 podpis">
					<div>{{__("Datum, kraj: ")}} <span class="accent">{{certifikat.datumizdaje}}, Hoče</span></div>
        			<div><div>Katja Sabolič</div><div>{{__("Direktorica")}}</div></div>
      			</div>

				 <div class="podatek pravilnik">
        		{{__("Ta certifikat potrjuje, da so navedene kmetijske rastline pridelane skladno s Pravilnikom o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja (Ur.l. RS 31/2023 s sprem. in dop.).")}}
				<br/>
				{{__("This certificate confirms, that tlisted agricultural plants have been produced in accordance to regulation -  Pravilnik o integrirani pridelavi poljščin, zelenjave, hmelja, sadja in oljk ter grozdja (Ur.l. RS 31/2023 s sprem. in dop.).")}}
      			</div>
			</div>

		</div>


      </div>

      <div class="noga-izven">
        <div class="stevilka-strani" :class="jezik"></div>
        <div class="info">Pivola 8, SI-2311 Hoče, {{__("telefon")}}: + 386 (0)2 6130831, -32, e-mail: info@ikc-um.si, www.ikc-um.si</div>
      </div>
      <!-- 5 -->
     
      <!-- 6 -->
     

 <div id="drugi-del">
<div class="celotna-sekcija">
 

      

    

	 
    </div>
      </div>
    </div>
</div>
</template>
<style scoped>
@media print{
  @page{
     margin-top: 10mm ;
margin-bottom: 20mm;
margin-left: 45mm ;
margin-right: 10mm ;
  }
}

.noga-info-group{
 break-inside: avoid !important ; 
}
.podatki .podatek{
	margin-bottom:0.5rem;
}
.pravilnik {
	font-size: 0.8rem;
}

.levi-stolpec {
   position:running(leviStolpecRunning);
   width:4.5cm;
   padding-left: 1cm;
  height: 27.7cm;
}
/*
297-30-10=257
*/
.levi-stolpec-napis{
  background-color:#fff200;
  width:3cm;
  height: 25.7cm; 
  border-radius: 1.5cm 0 1cm 0;
  justify-self: end;
 
  

}
.levi-logo{
  background-image:url('~@/assets/IKC-logo-01.svg');
  background-size:contain;
  background-repeat:no-repeat;
  height:2cm;
  width:3cm;
  left:0px;
  align-self:center;
  background-position: center

}
.eko-napis{
  color: #014671;
  text-transform:uppercase;
  width:15cm;
  height:2cm;
  font-size:1cm;
position:absolute;
transform:rotate(-90deg);
transform-origin: left top;
bottom: 0cm;
    left: 2cm;
    text-align: left;
}

.stevilka-strani:before{
  content: "Stran " counter(page) " od " counter(pages);
}

.stevilka-strani.lang-en:before{
  content: "Page " counter(page) " of " counter(pages);
}

.stevilka-strani.lang-de:before{
  content: "Seite " counter(page) " von " counter(pages);
}

.noga-izven{
  position:  running(nogaRunning);
  font-size: 3mm ;
  line-height:5mm;
  color:#014671;
 
}

@page {


  size: A4 portrait;
  
  @bottom-center {
    content:  element(nogaRunning);
    vertical-align: top;
}
 
 @left-middle {
    content:  element(leviStolpecRunning);
} 
}


</style>

<script>





import { mapState, mapActions } from 'vuex'
import CertifikatKategorija from './CertifikatKategorija.vue'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import { font, fontBold} from './support/includeFont.js'
import { Button, ButtonGroup } from '@progress/kendo-vue-buttons';
import { Previewer,registerHandlers,Handler  } from 'pagedjs';

class RepeatingTableHeaders extends Handler {
 /* constructor(chunker, polisher, caller) {
    super(chunker, polisher, caller);
  }

  afterPageLayout(pageElement, page, breakToken, chunker) {
    // Find all split table elements
    let tables = pageElement.querySelectorAll("table[data-split-from]");

    tables.forEach((table) => {
      // Get the reference UUID of the node
      let ref = table.dataset.ref;
      // Find the node in the original source
      let sourceTable = chunker.source.querySelector("[data-ref='" + ref + "']");
      // Find if there is a header
      let header = sourceTable.querySelector("thead");
      if (header) {
        // Clone the header element
        let clonedHeader = header.cloneNode(true);
        // Insert the header at the start of the split table
        table.insertBefore(clonedHeader, table.firstChild);
      }
    });

  }
  old but working*/ 
    constructor(chunker, polisher, caller) {
        super(chunker, polisher, caller);
        this.splitTablesRefs = [];
    }
	beforeParsed(content) {
		//console.log("Before preview!!!!!!!!!!!!!!!!!!!!!!")
		let gumbtiskaj=content.getElementById('tiskaj');
		//console.log("najdem gumb tiskaj")
		gumbtiskaj.remove();
		this.gumbtiskaj=gumbtiskaj;
	}
	afterPreview(content, renderTo) {
		let gumbtiskaj=this.gumbtiskaj;
	
		gumbtiskaj.style.position="fixed";
		gumbtiskaj.style.top="20px";
		gumbtiskaj.style.right="20px";
		gumbtiskaj.style.right="20px";
		gumbtiskaj.onclick=function(){
			this.remove();
			window.print();
			document.body.appendChild(this);
		}
		document.body.appendChild(this.gumbtiskaj);
		}

    afterPageLayout(pageElement, page, breakToken, chunker) {
        this.chunker = chunker;
        this.splitTablesRefs = [];

        if (breakToken) {
            const node = breakToken.node;
            const tables = this.findAllAncestors(node, "table");
            if (node.tagName === "TABLE") {
                tables.push(node);
            }

            if (tables.length > 0) {
                this.splitTablesRefs = tables.map(t => t.dataset.ref);

                //checks if split inside thead and if so, set breakToken to next sibling element
                let thead = node.tagName === "THEAD" ? node : this.findFirstAncestor(node, "thead");
                if (thead) {
                    let lastTheadNode = thead.hasChildNodes() ? thead.lastChild : thead;
                    breakToken.node = this.nodeAfter(lastTheadNode, chunker.source);
                }

                this.hideEmptyTables(pageElement, node);
            }
        }
    }

    hideEmptyTables(pageElement, breakTokenNode) {
        this.splitTablesRefs.forEach(ref => {
            let table = pageElement.querySelector("[data-ref='" + ref + "']");
            if (table) {
                let sourceBody = table.querySelector("tbody > tr");
                if (!sourceBody || this.refEquals(sourceBody.firstElementChild, breakTokenNode)) {
                    table.style.visibility = "hidden";
                    table.style.position = "absolute";
                    let lineSpacer = table.nextSibling;
                    if (lineSpacer) {
                        lineSpacer.style.visibility = "hidden";
                        lineSpacer.style.position = "absolute";
                    }
                }
            }
        });
    }

    refEquals(a, b) {
        return a && a.dataset && b && b.dataset && a.dataset.ref === b.dataset.ref;
    }

    findFirstAncestor(element, selector) {
        while (element.parentNode && element.parentNode.nodeType === 1) {
            if (element.parentNode.matches(selector)) {
                return element.parentNode;
            }
            element = element.parentNode;
        }
        return null;
    }

    findAllAncestors(element, selector) {
        const ancestors = [];
        while (element.parentNode && element.parentNode.nodeType === 1) {
            if (element.parentNode.matches(selector)) {
                ancestors.unshift(element.parentNode);
            }
            element = element.parentNode;
        }
        return ancestors;
    }

    // The addition of repeating Table Headers is done here because this hook is triggered before overflow handling
    layout(rendered, layout) {
        this.splitTablesRefs.forEach(ref => {
            const renderedTable = rendered.querySelector("[data-ref='" + ref + "']");
            if (renderedTable) {
                // this event can be triggered multiple times
                // added a flag repeated-headers to control when table headers already repeated in current page.
                if (!renderedTable.getAttribute("repeated-headers")) {
                    const sourceTable = this.chunker.source.querySelector("[data-ref='" + ref + "']");
                    this.repeatColgroup(sourceTable, renderedTable);
                    this.repeatTHead(sourceTable, renderedTable);
                    renderedTable.setAttribute("repeated-headers", true);
                }
            }
        });
    }

    repeatColgroup(sourceTable, renderedTable) {
        let colgroup = sourceTable.querySelectorAll("colgroup");
        let firstChild = renderedTable.firstChild;
        colgroup.forEach((colgroup) => {
            let clonedColgroup = colgroup.cloneNode(true);
            renderedTable.insertBefore(clonedColgroup, firstChild);
        });
    }

    repeatTHead(sourceTable, renderedTable) {
        let thead = sourceTable.querySelector("thead");
        if (thead) {
            let clonedThead = thead.cloneNode(true);
            renderedTable.insertBefore(clonedThead, renderedTable.firstChild);
        }
    }

    // the functions below are from pagedjs utils/dom.js
    nodeAfter(node, limiter) {
        if (limiter && node === limiter) {
            return;
        }
        let significantNode = this.nextSignificantNode(node);
        if (significantNode) {
            return significantNode;
        }
        if (node.parentNode) {
            while ((node = node.parentNode)) {
                if (limiter && node === limiter) {
                    return;
                }
                significantNode = this.nextSignificantNode(node);
                if (significantNode) {
                    return significantNode;
                }
            }
        }
    }

    nextSignificantNode(sib) {
        while ((sib = sib.nextSibling)) {
            if (!this.isIgnorable(sib)) return sib;
        }
        return null;
    }

    isIgnorable(node) {
        return (node.nodeType === 8) || // A comment node
            ((node.nodeType === 3) && this.isAllWhitespace(node)); // a text node, all whitespace
    }

    isAllWhitespace(node) {
        return !(/[^\t\n\r ]/.test(node.textContent));
    }

}

registerHandlers(RepeatingTableHeaders);





import ikcLogo from "../assets/ikc.png"
export default {
    props: ["certifikatid"],
    components:{"kategorija":CertifikatKategorija,'kbutton': Button,},
   
    
    computed:{
      ...mapState({certifikat(state) {
      
          return state.certifikat.certifikat;
        }}), 
    jezik:{
       get() {
        var l={};
        l["lang-"+this.$route.query.lang]=true;
        return l;
       }
    },


    
    },
     methods: {

        ...mapActions('certifikat', ['vrniPoId']),

        __p: function(value){
        
        if(!this.$route.query.lang)
            return value.certifikat


        else
            return value.info[this.$route.query.lang];


        },

       __: function(value){

        if(!this.$route.query.lang)
            return value


        let lang=this.$route.query.lang
        var translation={};

        translation["en"]={
                  "CERTIFIKAT":"CERTIFICATE",
                  "Imetnik":"Operator",
                  "Naslov":"Address",
				  "Vrste certificiranih kmetijskih rastlin":"",
				  "Kontrolna številka":"Control number",
                  "Številka certifikata":"Certificate number",
				  "Ekološko kmetijstvo":"Organic production",
                  "Ta certifikat zamenjuje predhodni certifikat št.:":"This document replaces the document with the number",
                  "Datum, kraj: ":"Date, place: ",
                  "Direktor:":"Director:",
                  "Certifikat je veljaven od":"Certificate valid from",
                  "do":"to",
                  "telefon":"telephone"

            };


            
        if(!translation[lang])
              return value;

        return translation[lang][value]?translation[lang][value]:value;


        }   
               
    

      },
    created()
  {

    console.log("Page refresh, checking properties");
        console.log(this.certifikatid);
      
      this.vrniPoId({id:this.certifikatid}).then(()=>{
         var stcertifikata=this.certifikat.stcertifikata;
        console.log(this.gridData);
         this.$nextTick(function () {
    
    console.log(document.getElementById('html'));
    let html=document.getElementById('html');

      let paged = new Previewer();
   
   
paged.preview();





  });
      });
  
     

  },
  mounted(){
   
 }
}
</script>
<style scoped>

.noga .sekcija{
  margin-bottom:0;
}



 




.certifikat.ovoj{

 font-size:4mm;
color: #111;
font-family: "Republika", arial, helvetica, sans-serif;
}

.glava.mali-ovoj {
display:flex;
flex-direction:row;
justify-content: center;
}




.glava.certifikat{
 

    display:flex;
    align-items:center;
    flex-direction:column;
    font-size:1em;
    text-decoration:none;
    justify-content:center;
    flex-grow:1;
    
}
.glava.certifikat h1{
  font-size:12mm;
  margin:0;
  letter-spacing: 4mm;
  line-height:12mm;
  margin-bottom:2mm
 
  }
  .glava.certifikat h2{
  font-size:6mm;
  margin:0;
  letter-spacing: 2mm;
  line-height:6mm;
  margin-bottom: 12mm
 
  }
.accent{
	color:#014671 !important;
	font-weight:bold;
}
.vrstica{
    display: flex;
 flex-direction: row;
 align-items: baseline; 
  margin-bottom :1em;
  border: 1mm solid #111;
  border-radius: 2mm;
  padding:2mm;
  gap:2mm;
}

.vrste {
	margin-bottom :1em;
  border: 1mm solid #111;
  border-radius: 2mm;
  padding:2mm;
  gap:2mm;

  min-height: 110mm;
}

.podatek {
display: flex;
flex-direction: row;
align-items: baseline; 
margin-bottom :1em;
  padding:2mm;
  gap:2mm;
}
.podpis{
	padding-right: 30mm;
	justify-content: space-between;
}
.sekcija {
     margin-bottom: 5mm;
   

}







</style>
